module.exports = __webpack_public_path__ + "img/telez.2792a2e6.jpg";